import { createRoute } from "@tanstack/react-router";
import { requirePermissions } from "@/app/guards";
import { ANALYTICS_PERMISSIONS } from "@/app/nav";
import { AnalyticsPage } from "@/features/analytics/AnalyticsPage";
import { staffRoute } from "@/routes/staff";

export type AnalyticsSearch = { from?: string; to?: string; group?: "day" | "week" | "month"; program?: string };

const date = (v: unknown) => (typeof v === "string" && /^\d{4}-\d{2}-\d{2}$/.test(v) ? v : undefined);

export const analyticsRoute = createRoute({
  getParentRoute: () => staffRoute,
  path: "analytics",
  // Set, never omit, each key: the router merges this over the raw query string.
  validateSearch: (search: Record<string, unknown>): AnalyticsSearch => ({
    from: date(search.from),
    to: date(search.to),
    group: search.group === "day" || search.group === "week" || search.group === "month" ? search.group : undefined,
    program: typeof search.program === "string" && search.program !== "" ? search.program : undefined,
  }),
  beforeLoad: ({ context }) => requirePermissions(context.session, ANALYTICS_PERMISSIONS),
  component: AnalyticsPage,
});
